<mat-sidenav-container style="height:100%;">
  <mat-sidenav #sidenav mat-component-id="sidenav" [opened]="true" mode="side">
      <mat-nav-list>
          <a mat-list-item routerLink="config" routerLinkActive="active">Trial Configuration</a>
      </mat-nav-list>
      <mat-nav-list>
          <a mat-list-item routerLink="logs" routerLinkActive="active">Trial Logs</a>
      </mat-nav-list>
  </mat-sidenav>
  <router-outlet></router-outlet>
</mat-sidenav-container>
